import { SamFormHelper } from './formHelper';

jQuery(function() {
  var formHelper = SamFormHelper;
  TabLinks.matchHeight();

  $('.sam-tablinks').on('click', function(event){
    $('.sam-required-error').remove();
    if ($(this).data('back-button') != true)
    { var active_tab = '';
      $('.sam-menu').children().each(function(){
        if ($(this).find('a.sam-tablinks').hasClass('active'))
        { active_tab = $(this).find('a.sam-tablinks'); }
      });

      var flag = checkRequired(active_tab.data('open-tab'));
      if (flag === true) { return false; }
    }

    TabLinks.openTab(event, $(this).data('open-tab'));
  });

  $('.sam-preview-edit').on('click', function(event) {
    $('.sam-preview-container').addClass('sam-hidden');
    $('.sam-form').removeClass('sam-hidden');
    TabLinks.openTab(event, $(this).data('open-tab'));
  });

  $('.sam-btn-add').on('click', function() {
    var source = $($(this).data('sam-add-next-to')),
      source_index = source.find('input:first').attr('name').match(/\[[0-9]+\]/)[0],
      index = Number(source_index.match(/[0-9]+/)[0]) + 1,
      hideLabels = $(this).data('sam-hide-labels');

    var target = source.clone();

    target.find('input').each(function(){
      $(this).val('');
      $(this).attr('name', $(this).attr('name').replace(source_index, '['+ index +']'));
    });

    if (hideLabels === true) {
      target.find('label').remove();
    }

    target.find('select').each(function(){
      $(this).find(':selected').removeAttr('selected');
      $(this).attr('name', $(this).attr('name').replace(source_index, '['+ index +']'));
    });

    if (index == 1){
      if (target.find('.sam-cs-remove-container').length > 0) {
        target.find('.sam-cs-remove-container').append('<a class=\'btn btn-primary btn-mini sam-btn-remove\' onclick=\'$(this).parent().parent().parent().remove();\'>Remove</a>');
      } else {
        target.append('<div class=\'row\'><a class=\'btn btn-primary sam-btn-remove\' onclick=\'$(this).parent().parent().remove();\'>Remove</a></div>');
      }
    }

    source.after(target);
    $('.sam_phone').mask('(999) 999-9999', {placeholder: '(   )    -    '});
  });



  // PB Person Reporting
  function ensureFieldForOtherRole(event) {
    if($('#sam_pb_submission_role').val() == 'Other'){
      formHelper.makeRequiredByName('role_other');
      $('.sam_pb_submission_role_other').show();
    } else {
      formHelper.removeRequiredByName('role_other');
      $('.sam_pb_submission_role_other').hide();
    }
  }

  $('#sam_pb_submission_role').on('change', ensureFieldForOtherRole);

  $('.sam-preview-container [data-open-tab="person_reporting_pb"]').click(ensureFieldForOtherRole);
  //-----------------

  // PB Description
  $('input#sam_pb_submission_incident_reported_true').click(function() {
    makeRequired('sam_reported_agency_name');
    $('div.sam_reported_agencies').show();
  });

  $('input#sam_pb_submission_incident_reported_false').click(function() {
    removeRequired('sam_reported_agency_name');
    $('div.sam_reported_agencies').hide();
  });
  //----------------

  // PB Details
  $('input#sam_pb_submission_person_arrested_true').click(function() {
    makeRequired('arrest_agency_name');
    $('div.reported_to_arrest_agency').show();
  });

  $('input#sam_pb_submission_person_arrested_false').click(function() {
    removeRequired('arrest_agency_name');
    $('div.reported_to_arrest_agency').hide();
  });

  $('#sam_pb_submission_involves_controlled_substance').on('click', function(){
    if ($(this).prop('checked') == true) {
      formHelper.makeRequiredByName('controlled_substance_name');
      $('.div_controlled_substance_name').show();
    } else {
      formHelper.removeRequiredByName('controlled_substance_name');
      $('.div_controlled_substance_name').hide();
    }
  });

  $('#sam_pb_submission_involves_legend_drug').on('click', function(){
    if ($(this).prop('checked') == true) {
      formHelper.makeRequiredByName('legend_drug_name');
      $('.div_involves_legend_drug').show();
    } else {
      formHelper.removeRequiredByName('legend_drug_name');
      $('.div_involves_legend_drug').hide();
    }
  });

  $('input#sam_pb_submission_tppp_bill_attempt_true').click(function() {
    makeRequired('tppp_administrator');
    $('div.sam_tppp_information').show();
  });

  $('input#sam_pb_submission_tppp_bill_attempt_false').click(function() {
    removeRequired('tppp_administrator');
    $('div.sam_tppp_information').hide();
  });

  $('input#sam_pb_submission_tp_admin_notified_true').click(function() {
    makeRequired('tp_admin_name');
    $('div.div_tp_admin_notified').show();
  });

  $('input#sam_pb_submission_tp_admin_notified_false').click(function() {
    removeRequired('tp_admin_name');
    $('div.div_tp_admin_notified').hide();
  });
  //----------------

  // TOLOCS details
  $('.sam-tolocs-incident-type-radio').on('click', function() {
    if($(this).val() == 'Employee - Licensed') {
      clearIncidentType('Transit - Theft');
      formHelper.makeRequiredByName('employee_name', 'tolocs');
      formHelper.makeRequiredByName('employee_license_number', 'tolocs');
      $('.sam-tolocs-incident-type-licensed').show();
    } else if($(this).val() == 'Transit - Theft') {
      clearIncidentType('Employee - Licensed');
      formHelper.makeRequiredByName('transit_carrier_name', 'tolocs');
      $('.sam-tolocs-incident-type-transit').show();
    } else {
      clearIncidentType('Employee - Licensed');
      clearIncidentType('Transit - Theft');
    }
  });

  function clearIncidentType(name) {
    if (name == 'Employee - Licensed') {
      $('#sam_tolocs_submission_licensee_reported_false').click();
      formHelper.removeRequiredByName('employee_license_number', 'tolocs');
      formHelper.removeRequiredByName('employee_name', 'tolocs');
      $('.sam-tolocs-incident-type-licensed').hide();
    } else if (name == 'Transit - Theft') {
      $('#sam_tolocs_submission_past_carrier_loss_false').click();
      formHelper.removeRequiredByName('transit_carrier_name', 'tolocs');
      $('.sam-tolocs-incident-type-transit').hide();
    }
  }

  $('.sam-tolocs-past-carrier-loss-radio').on('click', function() {
    if($(this).val() == 'true') {
      $('.sam-tolocs-past-carrier-loss').show();
    } else {
      $('.sam-tolocs-past-carrier-loss').hide();
    }
  });

  $('.sam-tolocs-licensee-reported-radio').on('click', function() {
    if($(this).val() == 'true') {
      formHelper.makeRequiredByName('licensee_reported_board', 'tolocs');
      formHelper.makeRequiredByName('licensee_reported_date', 'tolocs');
      $('.sam-tolocs-licensee-reported').show();
    } else {
      formHelper.removeRequiredByName('licensee_reported_board', 'tolocs');
      formHelper.removeRequiredByName('licensee_reported_date', 'tolocs');
      $('.sam-tolocs-licensee-reported').hide();
    }
  });

  $('.sam-tolocs-dea-notified-radio').on('click', function() {
    if($(this).val() == 'true') {
      $('.sam-tolocs-dea-notified').show();
    } else {
      $('.sam-tolocs-dea-notified').hide();
    }
  });

  $('.sam-tolocs-police-notified-radio').on('click', function() {
    if($(this).val() == 'true') {
      formHelper.makeRequiredByName('police_department_name', 'tolocs');
      formHelper.makeRequiredByName('investigator_name', 'tolocs');
      formHelper.makeRequiredByName('police_report_date', 'tolocs');
      $('.sam-tolocs-police-notified').show();
    } else {
      formHelper.removeRequiredByName('police_department_name', 'tolocs');
      formHelper.removeRequiredByName('investigator_name', 'tolocs');
      formHelper.removeRequiredByName('police_report_date', 'tolocs');
      $('.sam-tolocs-police-notified').hide();
    }
  });

  //----------------

  // Preview button
  $('.preview-btn').on('click', function(event){
    var flag = checkRequired($(this).data('current-tab'));

    if ($('.certification-box').is(':checked') == false){
      $('.certification-box').addClass('certification-box-error');
      flag == true;
    }

    if (flag === true) { event.preventDefault(); }
  });

  $('.certification-box').on('click', function(event) {
    if ($(this).hasClass('certification-box-error')) {
      $(this).removeClass('certification-box-error');
    }
  });
});

function makeRequired(fieldClass){
  $('.' + fieldClass).each(function() {
    $(this).attr('required', 'true');
  });

  $('label[for=' + fieldClass + ']').each(function(){
    $(this).addClass('required');
  });
}

function removeRequired(fieldClass){
  $('.' + fieldClass).each(function() {
    $(this).val('');
    $(this).removeAttr('required');
  });

  $('label[for=' + fieldClass + ']').each(function(){
    $(this).removeClass('required');
  });
}

function checkRequired(div) {
  var flag = false;

  $('#' + div).find(':input[required]').each(function() {
    if($(this).val() == '') {
      $(this).addClass('sam_field_with_errors');
      flag = true;
    } else if ($(this).is(':checkbox') && !$(this).is(':checked')) {
      $(this).addClass('sam_checkbox_with_error');
      flag = true;
    } else if ($(this).hasClass('sam_field_with_errors')) {
      $(this).removeClass('sam_field_with_errors');
    }
  });

  if (div == 'define_incident'){
    if (flag == false){
      flag = SamFormHelper.checkRequiredRadioButtons('pb', 'incident', 'no-div');
    }

    SamFormHelper.requireRadioButtonSelection('define_incident', 'input[name=\'sam_pb_submission[incident]\']');
  }

  if (div == 'registrant_info_toloc'){
    if (flag == false){
      flag = SamFormHelper.checkRequiredRadioButtons('tolocs', 'registrant_business', 'no-div');
    }
    SamFormHelper.checkRequiredRadioButtons('tolocs', 'registrant_business', 'sam-tolocs-registrant-business-error');
  }

  if (div == 'details_tolocs'){
    if (flag == false){
      flag = SamFormHelper.checkRequiredRadioButtons('tolocs', 'incident_type', 'no-div');
    }
    SamFormHelper.checkRequiredRadioButtons('tolocs', 'incident_type', 'sam-tolocs-incident-type-error');
  }

  if (div == 'method_cod') {
    if (flag == false){
      flag = SamFormHelper.checkRequiredRadioButtons('cod', 'destruction_method', 'no-div');
    }
    SamFormHelper.requireRadioButtonSelection('method_cod', 'input[name=\'sam_cod_submission[destruction_method]\']');
  }

  if (div == 'reason_cod') {
    if (flag == false){
      flag = SamFormHelper.checkRequiredRadioButtons('cod', 'destruction_reason', 'no-div');
    }
    SamFormHelper.requireRadioButtonSelection('reason_cod', 'input[name=\'sam_cod_submission[destruction_reason]\']');
  }

  $('#' + div).find(':input[data-length-validation]').each(function() {
    var length_flag = SamFormHelper.lengthValidation($(this));
    flag = flag || length_flag;
  });

  $('#' + div).find(':input[data-max-length-validation]').each(function() {
    var max_length_flag = SamFormHelper.maxLengthValidation($(this));
    flag = flag || max_length_flag;
  });

  return flag;
}

var TabLinks = (function($) {
  function openTab(evt, formName) {
    if ($(evt.currentTarget).data('prevent-default') === true) {
      return;
    }

    // Declare all variables
    var i, tabcontent, tablinks;

    // Get all elements with class="tabcontent" and hide them
    tabcontent = $('.tabcontent');
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = 'none';
    }

    // Get all elements with class="tablinks" and remove the class "active"
    tablinks = $('.sam-tablinks');
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(' active', '');
    }

    // Show the current tab, and add an "active" class to the link that opened the tab
    $('#' + formName).css('display', 'block');
    $('.sam-tablinks').removeClass('active');
    $('*[data-open-tab='+ formName +']').addClass('active');
    $('*[data-open-tab='+ formName +']').data('prevent-default', 'false');
    window.scrollTo(0, 0);
    matchHeight();
  }

  function matchHeight() {
    if ($('.sam-menu').height() < $('.sam-menu-content').height()) {
      $('.sam-menu').css('min-height', $('.sam-menu-content').height());
    } else if ($('.sam-menu').height() > $('.sam-menu-content').height()) {
      $('.sam-menu').css('height','auto');
      $('.sam-menu').css('min-height', $('.sam-menu-content').height());
    }
  }
  return {openTab:openTab,
    matchHeight:matchHeight};
})($);